<template>
  <div class="container exam-edit">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/read/list' }">阅读资料</el-breadcrumb-item>
        <el-breadcrumb-item>阅读资料编辑</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="left-item">
            <span style="margin:16px;">产品经理:</span>
            <!-- <el-autocomplete class="inline-input"
                             v-model="manager_admin_id"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入内容"
                             :trigger-on-focus="false"
                             @select="handleSelect"
                             clearable
                             style="width: 300px;margin-left:16px;"></el-autocomplete> -->
            <el-select v-model="manager_admin_ids"
                       placeholder="请选择产品经理"
                       style="width: 300px;margin-left:16px;"
                       multiple
                       filterable>
              <el-option v-for="item in $store.state.adminList||[]"
                         :key="item.id"
                         :label="item.nickname"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="right">
          <el-button plain
                     @click="handleClose">取消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">阅读资料详情设置</h3>
      <div class="content">
        <el-form class="dataForm"
                 :model="dataForm"
                 :rules="rules"
                 ref="dataForm"
                 label-width="110px">
          <div class="form-header">
            <div class="form-header-inner">基础信息</div>
          </div>
          <el-form-item label="上传主图："
                        prop="picture_url">
            <div class="cover-wrap">
              <div class="top">
                <div class="left">
                  <el-image class="cover-selected"
                            :src="dataForm.picture_url"
                            fit="cover" />
                  <p class="label">当前主图</p>
                </div>
                <div class="middle"></div>
                <div class="right">
                  <div class="covers">
                    <el-image class="cover-item"
                              fit="cover"
                              v-for="(item,index) in covers"
                              :key="index"
                              :src="item"
                              @click="handleCoverChange(item)" />
                  </div>
                  <p class="label">备选主图</p>
                </div>
              </div>
              <div>
                <el-upload class="avatar-uploader"
                           :action="imgUploadUrl"
                           :headers="uploadHeaders"
                           :show-file-list="false"
                           :on-success="handleUploadSuccess"
                           :before-upload="handleBeforeUpload">
                  <el-button size="small"
                             plain><i class="el-icon-upload2" />自定义主图</el-button>
                  <div slot="tip"
                       class="el-upload__tip"> 支持扩展名：.jpg .png .jpge ; 建议图片尺寸为750*422</div>
                </el-upload>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="资料名称："
                        prop="name">
            <el-input v-model="dataForm.name"
                      placeholder="输入阅读资料名称"></el-input>
          </el-form-item>
          <el-form-item label="资料简介："
                        prop="description">
            <el-input v-model="dataForm.description"
                      placeholder="输入资料简介"
                      type="textarea"
                      :rows="2"></el-input>
          </el-form-item>
          <el-form-item label="资料标签："
                        prop="tags">
            <el-input v-model="dataForm.tags"
                      placeholder="输入资料标签，多个用英文逗号隔开"></el-input>
          </el-form-item>
          <!-- <el-form-item label="专栏分类："
                        prop="category_id">
            <el-select v-model="dataForm.category_id"
                       placeholder="选择分类"
                       style="width: 300px">
              <el-option v-for="item in $store.state.readCategorys"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="专栏分类"
                        prop="category_ids">
            <el-select v-model="dataForm.category_ids"
                       placeholder="选择分类（可多选）"
                       style="width: 300px"
                       multiple>
              <el-option v-for="item in $store.state.readCategorys"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适合科目："
                        prop="subjects">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in subjects"
                      closable
                      :disable-transitions="false"
                      @close="handleSubjectRemove(item)">
                {{item.college_name ? `${item.college_name}-${item.name}` : item.name}}
              </el-tag>
              <el-button type="text"
                         @click="handleSubjectChoose">选择科目</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合专业："
                        prop="majors">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in majors"
                      closable
                      :disable-transitions="false"
                      @close="handleMajorRemove(item)">
                {{`${item.name}/${item.code}`}}
              </el-tag>
              <el-button type="text"
                         @click="handleMajorChoose">选择专业</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合院校："
                        prop="colleges">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in colleges"
                      closable
                      :disable-transitions="false"
                      @close="handleCollegeRemove(item)">
                {{`${item.name}`}}
              </el-tag>
              <el-button type="text"
                         @click="handleCollegeChoose">选择院校</el-button>
            </div>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item class="price"
                          label="售价："
                          prop="price">
              <el-input v-model="dataForm.price"
                        placeholder="输入售价"></el-input>
            </el-form-item>
            <el-form-item label="划线价："
                          prop="market_price">
              <el-input v-model="dataForm.market_price"
                        placeholder="输入划线价"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="花呗分期："
                        prop="year">
            <el-select v-model="dataForm.hb_fq_num_level"
                       placeholder="选择花呗分期"
                       style="width: 300px">
              <el-option label="含手续费"
                         :value="0">
              </el-option>
              <el-option label="三期免息"
                         :value="3">
              </el-option>
              <el-option label="六期免息"
                         :value="6">
              </el-option>
              <el-option label="十二期免息"
                         :value="12">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可试用次数："
                        prop="trial_count">
            <el-select class="free-num"
                       v-model="dataForm.trial_count"
                       placeholder=""
                       style="width: 300px">
              <el-option v-for="item in filter.trial_counts"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item label="基础在学数："
                          prop="virtual_count">
              <el-input v-model="dataForm.virtual_count"
                        placeholder="输入在学基础数"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="课程有效期："
                        prop="time">
            <el-radio-group v-model="radio"
                            @input="inputChange">
              <el-radio :label="1">截止时间</el-radio>
              <el-radio :label="2">有效期</el-radio>
            </el-radio-group>

            <div>
              <el-date-picker v-if="radio == 1"
                              :default-time="['00:00:00', '23:59:59']"
                              format="yyyy-MM-dd HH:mm"
                              class="datetime"
                              v-model="dataForm.datetime"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              style="width: 300px">
              </el-date-picker>
              <div v-else>
                <el-input style="width: 130px"
                          placeholder="请输入"
                          v-model="year">
                  <template slot="append"> 年 </template>
                </el-input>
                <el-input style="width: 130px;margin:0 5px"
                          placeholder="请输入"
                          v-model="month">
                  <template slot="append"> 月 </template>
                </el-input>
                <el-input style="width: 130px"
                          placeholder="请输入"
                          v-model="day">
                  <template slot="append"> 日 </template>
                </el-input>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="发布人："
                        prop="author_id">
            <el-select v-model="dataForm.author_id"
                       filterable
                       remote
                       reserve-keyword
                       :remote-method="fetchAuthorList"
                       placeholder="搜索作者，选择保存"
                       style="width: 300px">
              <el-option :label="`${item.realname}/${item.mobile}`"
                         :value="item.id"
                         v-for="item in authors"
                         :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人">
            <el-input v-model="creator"></el-input>
            <!-- <el-autocomplete class="inline-input"
                             v-model="creator"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入内容"
                             :trigger-on-focus="false"
                             @select="handleCreatorSelect"
                             clearable></el-autocomplete> -->
          </el-form-item>

          <el-form-item label="协议编码"
                        prop="product_agreement_codes">
            <el-select v-model="dataForm.product_agreement_codes"
                       placeholder="选择协议编码"
                       multiple
                       style="width: 300px">
              <el-option v-for="item in $store.state.agreementList||[]"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序值：">
            <el-input v-model="dataForm.sort"
                      placeholder="输入排序值"
                      style="width:300px;"
                      oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="打印服务：">
            <el-switch :active-value="1"
                       :inactive-value="0"
                       v-model="dataForm.print_service_status"
                       @change="turnOnOff()"></el-switch>
            <span class="pages"
                  v-if="dataForm.print_service_status">该资料总页数为{{dataForm.item_pdf_page_count }}页</span>
          </el-form-item>

          <el-form-item label="运费模板："
                        v-if="dataForm.print_service_status"
                        prop="template"
                        style="marginLeft:70px">
            <el-tag class="subject-item"
                    size="medium"
                    :disable-transitions="false"
                    v-if="dataForm.templateName !=''">
              {{dataForm.templateName}}
            </el-tag>
            <el-link type="primary"
                     :underline="false"
                     @click="handleDetail()">选择模板</el-link>
          </el-form-item>
          <el-form-item label="打印服务费："
                        v-if="dataForm.print_service_status"
                        prop="print_service_status">
            <el-input placeholder="请输入打印服务费"
                      v-model="printPrice"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      style="width:300px;">
              <span slot="append">元</span>
            </el-input>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item label="发送短信："
                          prop="sms_notify_status">
              <el-switch v-model="dataForm.sms_notify_status"></el-switch>
            </el-form-item>
            <el-form-item label="联系老师："
                          prop="contact_teacher_status">
              <el-switch v-model="dataForm.contact_teacher_status"
                         @change="handleContactSwitchChange"></el-switch>
            </el-form-item>
          </div>
          <div class="form-header">
            <div class="form-header-inner">服务老师</div>
          </div>
          <Teacher :content="{teachers: teachers }"
                   @save="saveTeacher" />
          <div class="form-header">
            <div class="form-header-inner">规格属性</div>
          </div>
          <Property :productId="dataForm.id"
                    :content="{skus: skus, properties: properties}"
                    @save="saveSkus"
                    :isPrint="dataForm.print_service_status" />
          <div class="form-header"
               style="display: flex;justify-content: space-between;align-items: center;">
            <div class="form-header-inner">详情描述</div>
            <el-switch v-model="editTypes"
                       active-text="百度编辑器"
                       inactive-text="默认编辑器"
                       @change="editChange">
            </el-switch>
          </div>
          <el-form-item class="course-detail"
                        label="资料详情："
                        prop="detail">
            <VueEditor v-if="!editTypes"
                       :content="dataForm.detail"
                       placeholder="请输入专栏描述，可以是图片也可以是文字，排版尽量美化，有助于用户购买"
                       @change="handleDetailChange" />
            <UEeditor :setDataStr="dataForm.detail"
                      @change="initDtaForm"
                      v-else />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"></SubjectChoose>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>
    <Record :isVisible="recordDialog"
            @choseList="choseList"
            :dataForm="dataForm"
            @close="recordDialog = false"
            :type="'order_read'"></Record>
  </div>
</template>

<script>
import { expressTemplateDetail, expressTemplateList } from '@/api/index.js'
import Teacher from '../product/teacher'
import Record from '@/components/dialog/subject/record'
import Property from '../product/property'
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
import MajorChoose from '@/components/dialog/major/MajorChoose'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { readUpdate, readOne } from '@/api/read'
import { seniorList } from '@/api/senior'
import UEeditor from '@/components/UEeditor'
import VueEditor from '@/components/VueEditor'

export default {
  components: {
    UEeditor,
    Property,
    Teacher,
    SubjectChoose,
    MajorChoose,
    CollegeChoose,
    VueEditor,
    Record,
  },
  data() {
    var checkTime = (rule, value, callback) => {
      if (this.radio == 1) {
        if (!this.dataForm.datetime || !this.dataForm.datetime.length) {
          callback(new Error('请选择截止时间'))
        }
        callback()
      } else {
        let regular = /^([0]|[1-9][0-9]*)$/
        if (
          (!this.year && !this.month && !this.day) ||
          (this.year == 0 && this.month == 0 && this.day == 0)
        ) {
          callback(new Error('请输入有效期'))
        }

        if (
          (this.year && !regular.test(this.year)) ||
          (this.month && !regular.test(this.month)) ||
          (this.day && !regular.test(this.day))
        ) {
          callback(new Error('请输入正整数'))
        }

        callback()
      }
    }
    return {
      editTypes: false,
      printPrice: 0,
      chose: {},
      query: {
        name: '',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      templateList: [],
      templateId: '',
      recordDialog: false,
      radio: 1,
      year: '',
      month: '',
      day: '',
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      covers: [
        'https://upload.kaoyanbox.net/exam_political.png',
        'https://upload.kaoyanbox.net/exam_english_1.png',
        'https://upload.kaoyanbox.net/exam_english_2.png',
        'https://upload.kaoyanbox.net/exam_math_1.png',
        'https://upload.kaoyanbox.net/exam_math_2.png',
        'https://upload.kaoyanbox.net/exam_math_3.png',
        'https://upload.kaoyanbox.net/exam_management.png',
        'https://upload.kaoyanbox.net/exam_common.png',
      ],
      dataForm: {
        templateName: '',
        picture_url: '',
        datetime: [],
      },
      subjects: [],
      majors: [],
      colleges: [],
      teachers: [],
      authors: [],
      skus: [],
      properties: [],
      filter: {
        discounts: [
          { label: '无优惠', value: 1 },
          { label: '会员免费', value: 0 },
          { label: '9折', value: 0.9 },
          { label: '8折', value: 0.8 },
          { label: '7折', value: 0.7 },
          { label: '6折', value: 0.6 },
          { label: '5折', value: 0.5 },
          { label: '4折', value: 0.4 },
          { label: '3折', value: 0.3 },
          { label: '3折', value: 0.2 },
          { label: '1折', value: 0.1 },
        ],
        trial_counts: [
          { label: '无试用', value: 0 },
          { label: '1次', value: 1 },
          { label: '2次', value: 2 },
          { label: '3次', value: 3 },
          { label: '4次', value: 4 },
          { label: '5次', value: 5 },
          { label: '6次', value: 6 },
          { label: '7次', value: 7 },
          { label: '8次', value: 8 },
        ],
      },
      rules: {
        // template: [{ required: true, message: '请选择模板', trigger: 'blur' }],
        name: [
          { required: true, message: '请输入阅读资料名称', trigger: 'blur' },
        ],
        time: [
          { validator: checkTime, trigger: 'change' },
          // { required: true, message: "请设置课程有效日期", trigger: "change" },
        ],
        description: [
          { required: true, message: '请输入阅读资料介绍', trigger: 'blur' },
        ],
        detail: [
          { required: true, message: '请输入资料详情', trigger: 'blur' },
        ],
        market_price: [
          { required: true, message: '请输入划线价', trigger: 'blur' },
        ],
        price: [{ required: true, message: '请输入售价', trigger: 'blur' }],
        trial_count: [
          { required: true, message: '请选择可试用次数', trigger: 'blur' },
        ],
        author_id: [
          { required: false, message: '请选择作者/学长', trigger: 'blur' },
        ],
        print_service_status: [
          { required: true, message: '请输入打印服务费', trigger: 'blur' },
        ],
        picture_url: [
          {
            required: true,
            message: '请上传主图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.dataForm.picture_url) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        category_id: [
          { required: true, message: '请选择专栏分类', trigger: 'blur' },
        ],
        category_ids: [
          {
            required: true,
            message: '请选择课程分类',
            trigger: 'change',
            type: 'array',
            min: 1,
          },
        ],
        // subjects: [
        //   { required: true, message: '请选择适合科目', trigger: 'change', validator: (rule, value, callback) => {
        //     if (!this.subjects.length) {
        //       return callback(new Error(rule.message))
        //     } else {
        //       callback()
        //     }
        //   }}
        // ]
      },
      // manager_admin_id: '',
      manager_admin_ids: [],

      creator: '',
    }
  },
  computed: {
    printPrice: {
      get() {
        return (this.dataForm.item_pdf_page_count * 0.1).toFixed(2)
      },
    },
  },
  created() {
    this.fetchReadInfo()
  },

  watch: {
    // 时间数据监听
    'dataForm.datetime': {
      handler(value) {
        if (value) {
          this.dataForm.start_time = this.$moment(value[0]).valueOf()
          this.dataForm.end_time = this.$moment(value[1]).valueOf()
        } else {
          this.dataForm.start_time = null
          this.dataForm.end_time = null
        }
      },
    },
  },
  mounted() {
    this.$store.dispatch('getAdminList')
    this.$store.dispatch('fetchAgreementList')
  },

  methods: {
    handleContactSwitchChange(value) {
      // 如果开关要开启，检查是否有售后老师
      if (value) {
        const hasAfterSalesTeacher = this.teachers.some(
          (teacher) => teacher.type === 3
        )

        if (!hasAfterSalesTeacher) {
          this.$message.warning('请先添加售后老师再开启联系老师功能')
          // 恢复开关状态为关闭
          this.$nextTick(() => {
            this.dataForm.contact_teacher_status = false
          })
          return
        }
      }
      // 开关关闭时直接通过，不做限制
    },
    editChange(val) {
      this.editTypes = val
    },
    turnOnOff() {
      this.templateLists()
    },

    // 获取运费模板列表
    templateLists() {
      expressTemplateList(this.query).then((res) => {
        if (this.dataForm.templateName == undefined) {
          this.dataForm.deliver_express_template_id = res.list[0].id
          this.dataForm.templateName = res.list[0].name
          this.dataForm = { ...this.dataForm }
        }
      })
    },
    choseList(val) {
      this.templateId = val[0].id
      this.dataForm.templateName = val[0].name
    },
    handleDetail() {
      this.recordDialog = true
    },
    inputChange() {
      if (this.radio == 1) {
        this.year = ''
        this.month = ''
        this.day = ''
      } else {
        this.dataForm.datetime = null
      }
    },
    // 阅读资料基本信息
    fetchReadInfo() {
      readOne({ id: this.$route.params.readId }).then((res) => {
        if (res) {
          if (res.start_time && res.end_time) {
            res.datetime = [
              this.$moment(res.start_time),
              this.$moment(res.end_time),
            ]
            this.radio = 1
          } else {
            this.radio = 2
            let dayNum = res.enable_duration_second / 86400
            this.year = Math.floor(dayNum / 365)
            this.month = Math.floor((dayNum % 365) / 30)
            this.day = (dayNum % 365) % 30
          }

          this.subjects = res.subjects || this.subjects
          this.colleges = res.colleges || this.colleges
          this.majors = res.majors || this.majors
          if (this.majors.length > 0) {
            this.majors.map((item) => {
              if (item.code == '000000') {
                item.name = '公共课'
                item.level = '3'
                item.id = 1233
              }
              if (item.code == '000001') {
                item.name = '考研政治'
                item.level = '3'
                item.id = 1244
              }
              if (item.code == '000002') {
                item.name = '考研英语'
                item.level = '3'
                item.id = 1255
              }
              if (item.code == '000003') {
                item.name = '考研数学'
                item.level = '3'
                item.id = 1266
              }
              if (item.code == '000004') {
                item.name = '199管理类联考'
                item.level = '3'
                item.id = 1277
              }
            })
          }
          this.teachers = res ? res.teachers : []
          this.authors = res.author ? [res.author] : []
          if (
            res.manager_admin_id &&
            this.$store.state.adminList.findIndex((v) => {
              return v.id == res.manager_admin_id
            }) > -1
          ) {
            this.manager_admin_id =
              this.$store.state.adminList.find((v) => {
                return v.id == res.manager_admin_id
              }).nickname || ''
          }
          if (
            res.creator &&
            this.$store.state.adminList.findIndex((v) => {
              return v.id == res.creator
            }) > -1
          ) {
            this.creator =
              this.$store.state.adminList.find((v) => {
                return v.id == res.creator
              }).nickname || ''
          }
          this.skus = res.skus || this.skus
          this.properties = res.properties || this.properties

          this.dataForm = res
          this.printPrice = res.print_service_basic_price * 1
          if (this.dataForm.deliver_express_template_id != null) {
            let data = {
              id: this.dataForm.deliver_express_template_id,
            }
            expressTemplateDetail(data).then((res) => {
              this.$set(this.dataForm, 'templateName', res.name)
            })
          }

          if (this.dataForm.product_agreement_codes) {
            this.dataForm.product_agreement_codes =
              this.dataForm.product_agreement_codes.split(',')
          }
          res.sms_notify_status = res.sms_notify_status === 1 ? true : false
          res.contact_teacher_status =
            res.contact_teacher_status === 1 ? true : false
          if (this.dataForm.category_ids) {
            let arr = this.dataForm.category_ids.split(',')
            this.dataForm.category_ids = arr.map((v) => {
              return Number(v)
            })
          }
          if (this.dataForm.manager_admin_ids) {
            let arr = this.dataForm.manager_admin_ids.split(',')
            this.manager_admin_ids = arr.map((v) => {
              return Number(v)
            })
          }
        }
      })
    },
    fetchAuthorList(name) {
      seniorList({ keyword: name, isPaging: 0 }).then((res) => {
        this.authors = res.list
      })
    },
    // 图文详情
    handleDetailChange(editor) {
      this.dataForm.detail = editor.html
    },
    handleSubmit() {
      if (this.dataForm.contact_teacher_status) {
        const hasAfterSalesTeacher = this.teachers.some(
          (teacher) => teacher.type === 3
        )
        if (!hasAfterSalesTeacher) {
          this.$message.error('开启联系老师功能后，必须添加售后老师')
          return
        }
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = {
            id: this.dataForm.id,
            name: this.dataForm.name,
            description: this.dataForm.description,
            tags: this.dataForm.tags,
            detail: this.dataForm.detail,
            picture_url: this.dataForm.picture_url,
            author_id: this.dataForm.author_id,
            virtual_count: this.dataForm.virtual_count,
            subjects: this.subjects.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            majors: this.majors.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            colleges: this.colleges.map((item) => ({ code: item.code })),
            teachers: this.teachers.map((item) => ({
              id: item.id,
              type: item.type,
              sort: item.sort,
            })),
            skus: this.skus,
            market_price: Number(this.dataForm.market_price),
            price: Number(this.dataForm.price),
            trial_count: this.dataForm.trial_count,
            // category_id: this.dataForm.category_id,
            category_ids: this.dataForm.category_ids.join(','),
            hb_fq_num_level: this.dataForm.hb_fq_num_level,
            // manager_admin_id: this.dataForm.manager_admin_id,
            manager_admin_ids: this.manager_admin_ids.join(','),
            creator: this.dataForm.creator,
            sort: this.dataForm.sort,
            print_service_status: this.dataForm.print_service_status,
            print_service_basic_price: this.printPrice * 1,
            product_agreement_codes: this.dataForm.product_agreement_codes
              ? this.dataForm.product_agreement_codes.join(',')
              : '',
            start_time: this.dataForm.start_time,
            end_time: this.dataForm.end_time,
            enable_duration_second:
              this.year || this.month || this.day
                ? (Number(this.year) * 365 +
                    Number(this.month) * 30 +
                    Number(this.day) * 1) *
                  86400
                : null,
            sms_notify_status: this.dataForm.sms_notify_status ? 1 : 0,

            contact_teacher_status: this.dataForm.contact_teacher_status
              ? 1
              : 0,
          }
          if (this.dataForm.print_service_status === 1) {
            params.print_service_status = 1
            params.is_deliver = 1
            params.print_service_page_price = 0.1
            params.deliver_express_template_id = this.templateId
              ? this.templateId
              : this.dataForm.deliver_express_template_id
          } else if (this.dataForm.print_service_status === 0) {
            params.print_service_status = 0
            params.is_deliver = 0
            params.print_service_page_price = null
            params.deliver_express_template_id = null
          }
          // if(this.dataForm.print_service_status==1){
          //  params.print_service_page_price= 0.1,
          //  params. deliver_express_template_id= this.templateId
          //     ? this.templateId
          //     : this.dataForm.deliver_express_template_id,
          // }
          readUpdate(params)
            .then((res) => {
              this.$message.success(`更新成功`)
              this.$refs['dataForm'].resetFields()

              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id)
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    saveMajor({ majors }) {
      this.majors = majors
      console.log('this.majors', this.majors)
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    saveTeacher({ teachers }) {
      this.teachers = teachers
    },
    saveSkus(val) {
      if (val.skus) {
        this.skus = val.skus
      }
      if (val.properties) {
        this.properties = val.properties
      }
      if (!this.properties.length) {
        this.skus = []
      }
    },
    handleClose() {
      this.$router.go(-1)
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.picture_url = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!')
      }
      return isLt2M
    },
    handleCoverChange(url) {
      this.dataForm.picture_url = url
    },
    initDtaForm(e) {
      this.dataForm.detail = e
    },
    querySearch(queryString, cb) {
      var restaurants = this.$store.state.adminList.map((v) => {
        return {
          value: v.nickname,
          id: v.id,
        }
      })
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handleSelect(item) {
      this.dataForm.manager_admin_id = item.id
    },
    handleCreatorSelect(item) {
      this.dataForm.creator = item.id
    },
  },
}
</script>

<style scoped lang="less">
.pages {
  margin-top: -5rpx;
  display: inline-block;
  font-size: 14px;
  margin-left: 5px;
}
.exam-edit {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;

    .dataForm {
      min-width: 700px;
      width: 100%;
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
    .cover-wrap {
      .top {
        display: flex;
        margin-bottom: 10px;
      }
      .left,
      .right {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .middle {
        flex: 1;
      }
      .cover-selected {
        height: 92px;
      }
      .covers {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: space-between;
        width: 300px;
      }
      .cover-item {
        width: 70px;
        height: 70px;
        cursor: pointer;
        margin-bottom: 5px;

        &:not(:nth-child(4n)) {
          margin-right: 5px;
        }
      }
      .el-upload__tip {
        line-height: 20px;
      }
    }
    .form-item-wrap {
      display: flex;

      /deep/ .el-input {
        width: 300px;
      }
    }
    .course-detail {
      /deep/ .el-form-item__content {
        line-height: 1;
      }
    }
    .tag-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .subject-item,
    .teacher-item {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }

  .form-header {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    background: #f8f8f8;
    margin-bottom: 20px;

    .form-header-inner {
      padding: 10px;
    }
  }
}
</style>
